import { app } from "@microsoft/teams-js";

let teamsInitialized = false;
let runningInTeams = false;

export function isInMicrosoftTeams(): boolean {
  if (runningInTeams) {
    return true;
  }

  try {
    if (window.self === window.top) {
      return false;
    }

    const referrer = document.referrer.toLowerCase();
    return (
      referrer.includes("teams.microsoft.com") ||
      referrer.includes("teams.live.com") ||
      referrer.includes("teams.office.com") ||
      referrer.includes("teams.cloud.microsoft")
    );
  } catch {
    return false;
  }
}

export async function initializeTeamsApp(): Promise<boolean> {
  if (teamsInitialized) {
    return runningInTeams;
  }

  try {
    await app.initialize();
    teamsInitialized = true;
    runningInTeams = true;
    return true;
  } catch {
    runningInTeams = isInMicrosoftTeams();
    teamsInitialized = true;
    return runningInTeams;
  }
}
